@if (rule) {
  <rask-input
    [raskRule]="rule"
    raskRuleDisplayType="Popover"
    [placeholder]="placeholder"
    class="cell grid"
    [(ngModel)]="value"
    [readonly]="readonly">
  </rask-input>
}
@if (!rule) {
  <rask-input
    [placeholder]="placeholder"
    class="cell"
    [(ngModel)]="value"
    [readonly]="readonly">
  </rask-input>
}
